import { Component, AfterViewInit, Inject } from '@angular/core';
import { ToasterService, BodyOutputType } from 'angular2-toaster';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthFacade } from '@ecosure-suite/back-office/auth/data-access-auth';
import { CountDownFacade } from '@ecosure-suite/common/count-down/data-access-count-down';
import { tap } from 'rxjs/operators';
import { CountDownComponent } from '../count-down';
import {
  COUNTDOWN_CONFIGURATION_TOKEN,
  CountDownConfigurationToken
} from '../../tokens';

@Component({
  selector: 'es-count-down-timer',
  template: ``
})
export class CountDownTimerComponent implements AfterViewInit {
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private authService: AuthFacade,
    private toasterService: ToasterService,
    private countDownService: CountDownFacade,
    @Inject(COUNTDOWN_CONFIGURATION_TOKEN)
    configuration: CountDownConfigurationToken
  ) {
    this.idle.onIdleStart
      .pipe(
        tap(() => {
          this.toasterService.clear();
          this.toasterService.pop({
            type: 'warning',
            title: 'Idle!',
            timeout: 0,
            body: CountDownComponent,
            bodyOutputType: BodyOutputType.Component
          });
        })
      )
      .subscribe();
    // sets an idle timeout.
    this.idle.setIdle(configuration.idleInterval);
    // sets a timeout period.
    this.idle.setTimeout(configuration.timeoutInterval);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // sets the ping interval to 15 seconds
    this.keepalive.interval(configuration.pingInterval);

    this.idle.watch();
  }

  ngAfterViewInit(): void {
    this.idle.onTimeoutWarning.subscribe(countdown =>
      this.countDownService.update(countdown)
    );

    this.idle.onIdleEnd.subscribe(() => this.clear());

    this.idle.onTimeout.subscribe(() => {
      this.clear();
      this.authService.logout();
    });
  }

  clear() {
    this.toasterService.clear();
  }
}
